import { render, staticRenderFns } from "./TaskItem.vue?vue&type=template&id=2b48bd1f&scoped=true&lang=pug&"
import script from "./TaskItem.vue?vue&type=script&lang=js&"
export * from "./TaskItem.vue?vue&type=script&lang=js&"
import style0 from "./TaskItem.vue?vue&type=style&index=0&id=2b48bd1f&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b48bd1f",
  null
  
)

export default component.exports